import { FC, useMemo } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import CheckboxInactiveSvg from "@/assets/svg/CheckboxInactiveSvg";
import CheckboxActiveSvg from "@/assets/svg/CheckboxActiveSvg";
import PlaceholderArticleImg from "@/assets/svg/PlaceholderArticleImg";
import theme from "@/theme";

interface DraftItemProps {
  text: string;
  image?: string;
  checked: boolean;
  onCheck: (value: boolean) => void;
  activeTab?: string;
  onClick: any;
  title?: string | null;
}

const DraftItem: FC<DraftItemProps> = ({
  text,
  image,
  checked,
  onCheck,
  activeTab,
  onClick,
  title,
}) => {
  const parsedText = useMemo(() => {
    const parts = text.split(/(\$[^\s]+)/g);

    return parts.map((part, idx) => {
      const isTag = part.startsWith("$") && part.length > 1;

      if (isTag) {
        const withoutDollar = part.slice(1);
        if (!/^\d+$/.test(withoutDollar)) {
          return (
            <Typography
              key={idx}
              component="span"
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "15px",
                color: theme.palette.custom.mainBlue,
              }}
            >
              {part}
            </Typography>
          );
        }
      }

      return (
        <Typography
          key={idx}
          component="span"
          sx={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "15px",
            color: "#7D8690",
          }}
        >
          {part}
        </Typography>
      );
    });
  }, [text]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "119px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          justifyContent: "space-between",
          borderBottom: "1px solid #F4F5F6",
        }}
      >
        <Box
          sx={{
            height: "119px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            borderBottom: "1px solid #F4F5F6",
            cursor: "pointer",
            width: "100%",
            maxWidth: "92%",
          }}
          onClick={onClick}
        >
          {/* IMAGE */}
          {activeTab === "Articles" &&
            (image ? (
              <Box
                component="img"
                src={image}
                alt=""
                sx={{
                  width: "116px",
                  height: "86px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  border: "1px solid #E5E7EB",
                }}
              />
            ) : (
              <PlaceholderArticleImg />
            ))}

          {/* TEXT */}
          <Box
            sx={{
              maxHeight: "75px",
              maxWidth: "755px",
              width: "100%",
              flex: 1,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              whiteSpace: "normal",
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "15px",
              letterSpacing: "0%",
              color: "#7D8690",
            }}
          >
            {title && (
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: "15px",
                  letterSpacing: "0%",
                  color: "#7D8690",
                  flex: 1,
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 3,
                  whiteSpace: "normal",
                }}
              >
                {title}
                <br />
                <br />
              </Typography>
            )}
            {parsedText}
          </Box>

          {/* IMAGE */}
          {activeTab === "Posts" && image && (
            <Box
              component="img"
              src={image}
              alt=""
              sx={{
                width: "116px",
                height: "86px",
                objectFit: "cover",
                borderRadius: "4px",
                border: "1px solid #E5E7EB",
              }}
            />
          )}
        </Box>
        {/* CHECKBOX */}
        <Checkbox
          checked={checked}
          onChange={(e) => onCheck(e.target.checked)}
          onMouseDown={(e) => e.stopPropagation()}
          icon={<CheckboxInactiveSvg />}
          checkedIcon={<CheckboxActiveSvg />}
          sx={{
            padding: 0,
            margin: "4px",
            cursor: "pointer",
            "& svg": {
              width: "18px",
              height: "18px",
            },
          }}
        />
      </Box>
    </>
  );
};

export default DraftItem;
